import React, { useState, useEffect } from 'react'
import * as echarts from 'echarts';


export default function EChartsLogo({params}) {

  
  var chartDom;
  var myChart;

  var option = {
    graphic: {
      elements: [
        {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: params,
            fontSize: 26,
            fontWeight: 'bold',
            lineDash: [0, 200],
            lineDashOffset: 0,
            fill: 'transparent',
            stroke: 'white',
            lineWidth: 1
          },
          keyframeAnimation: {
            duration: 5000,
            loop: true,
            keyframes: [
              {
                percent: 0.7,
                style: {
                  fill: 'transparent',
                  lineDashOffset: 200,
                  lineDash: [200, 0]
                }
              },
              {
                // Stop for a while.
                percent: 0.8,
                style: {
                  fill: 'transparent'
                }
              },
              {
                percent: 1,
                style: {
                  fill: 'white'
                }
              }
            ]
          }
        }
      ]
    }
  };


  useEffect(() => {
    chartDom = document.getElementById('logo');
    myChart = echarts.init(chartDom);
    myChart.setOption(option);
    option && myChart.setOption(option);
  }, [])




  return (
    <div style={{ textAlign: "center" }}>
      <div id="logo" style={{ width: "100%", height: "31px" }} />
    </div>
  )
}
